// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import request from '../http/request';
import { setError } from './error';
import { toastr } from 'react-redux-toastr';

/** ************************
 * Config bundle
 ************************ */
// Actions
const APP_CONFIG_REQUESTED = 'Fetching app config';
const APP_CONFIG_SUCCESS = 'App config fetched';
const APP_CONFIG_FAILURE = 'Failed to fetch app config';

// Reducer
export default function reducer(state = {}, action) {
    switch (action.type) {
        case APP_CONFIG_REQUESTED:
            return Object.assign({}, state, { isFetching: true });
        case APP_CONFIG_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                ...action.config,
            });
        case APP_CONFIG_FAILURE:
            return Object.assign({}, state, { isFetching: false });
        default:
            return state;
    }
}

// Action Creators/Thunks
const requestAppConfig = () => ({ type: APP_CONFIG_REQUESTED });
const appConfigSuccess = config => ({ type: APP_CONFIG_SUCCESS, config });
const appConfigFailure = () => ({ type: APP_CONFIG_FAILURE });

export const fetchAppConfig = () => dispatch => {
    dispatch(requestAppConfig());

    return request.get('/api/').then(
        responseJSON => dispatch(appConfigSuccess(responseJSON)),
        error => {
            dispatch(setError(error));
            dispatch(appConfigFailure());
            toastr.error(
                'Could not fetch application config. If applicable, check your network or VPN connection...'
            );
        }
    );
};
